import { SupportArticleModel } from "model/SupportArticle.model";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = SupportArticleModel[];

export const useDefaultObservableSupportArticleModelArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectSupportArticleModelArray extends BehaviorSubject<CurrentType> {}
